'use strict';
var _ = require('underscore');

module.exports = function(Handlebars) {
  Handlebars.registerHelper('truncate', function(str, len) {
    if (str && str.length > len && str.length > 0) {
      var newStr = str + ' ';
      newStr = str.substr(0, len);
      newStr = str.substr(0, newStr.lastIndexOf(' '));
      newStr = (newStr.length > 0) ? newStr : str.substr(0, len);
      return new Handlebars.SafeString(newStr + '...');
    }
    return str;
  });

  Handlebars.registerHelper('debugJson', function(context, indent) {
    if (typeof indent === 'undefined') { indent = 2; }
    // Pretty print JSON
    return JSON.stringify(context, null, indent);
  });

  Handlebars.registerHelper('toLowerCase', function(str) {
    if (str && str.length > 0) {
      return str.toLowerCase();
    }
    return str;
  });

  Handlebars.registerHelper('concat', function(str1, str2) {
    return str1 + str2;
  });

  Handlebars.registerHelper('times', (times, options) => {
    let str = '';
    _(times).times((i) => {
      str += options.fn(i);
    });
    return str;
  });

  Handlebars.registerHelper('replace', function(str, char1, char2) {
    return str.replaceAll(char1, char2);
  });

  Handlebars.registerHelper('reverseArray', function(array) {
    return array.reverse();
  });

  Handlebars.registerHelper('renderSVG', function(width, height, color) {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '" fill="' + color + '" viewBox="0 0 16 16"><path d="M15.83 13.23l-7-11.76a1 1 0 0 0-1.66 0L.16 13.3c-.38.64-.07 1.7.68 1.7H15.2c.74 0 1.01-1.13.63-1.77zm-7 .37H7.14v-1.71h1.7zm0-3.57H7.16L7 4h2z"></path></svg>';
    const SVG64 = btoa(svg);
    return 'data:image/svg+xml;base64,' + SVG64;
  });

  Handlebars.registerHelper('downloadIconSVG', function() {
    const svg = '<?xml version="1.0" encoding="UTF-8"?><svg version="1.1" width="24px" height="24px" viewBox="0 0 24.0 24.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="i0"><path d="M19.2497088,13.1182925 C19.629552,13.1182925 19.943469,13.3957745 19.9931507,13.7557887 L20,13.8558741 L20,18.2789762 C20,19.1819466 19.2926152,19.9224972 18.3929035,19.9942949 L18.2493206,20 L1.75067944,20 C0.832149563,20 0.0788382577,19.3045979 0.00580345186,18.4201269 L0,18.2789762 L0,13.8558741 C0,13.448519 0.335916808,13.1182925 0.75029119,13.1182925 C1.13013437,13.1182925 1.4440514,13.3957745 1.49373311,13.7557887 L1.50058238,13.8558741 L1.50058238,18.2789762 C1.50058238,18.3953633 1.58284772,18.4928619 1.69333448,18.5183434 L1.75067944,18.5248367 L18.2493206,18.5248367 C18.3677132,18.5248367 18.4668918,18.4439649 18.4928124,18.3353497 L18.4994176,18.2789762 L18.4994176,13.8558741 C18.4994176,13.448519 18.8353344,13.1182925 19.2497088,13.1182925 Z M10.0027812,0 C10.3826244,0 10.6966123,0.277310693 10.746386,0.637312563 L10.7532609,0.737396329 L10.756,14.002 L14.7312827,10.3510649 C15.0340743,10.0729728 15.5088582,10.0888377 15.7917422,10.3865002 C16.0489095,10.6571024 16.0589509,11.0674393 15.8311595,11.3487443 L15.7556963,11.4289961 L11.1924594,15.6199977 C10.5583064,16.202421 9.59395343,16.2357669 8.92200763,15.7206493 L8.79959644,15.6176376 L4.25613755,11.4279846 C3.95391415,11.1492958 3.93872855,10.6825236 4.22221955,10.3854197 C4.47993864,10.1153253 4.89577702,10.0784338 5.19631899,10.2833414 L5.28274928,10.3520763 L9.256,14.015 L9.25267851,0.737766964 C9.25257442,0.330411882 9.58840682,0 10.0027812,0 Z"></path></clipPath></defs><g transform="translate(1.9999999999999964 1.9999999999999964)"><g clip-path="url(#i0)"><polygon points="0,0 20,0 20,20 0,20 0,0" stroke="none" fill="#0069AA"></polygon></g></g></svg>';
    const SVG64 = btoa(svg);
    return 'data:image/svg+xml;base64,' + SVG64;
  });

  Handlebars.registerHelper('getFileNameWithoutExtension', function(dataUri) {
    let filename = dataUri && dataUri.indexOf('/') !== -1 ? dataUri.substring((dataUri.lastIndexOf('/') + 1)) : dataUri;
    if (filename && filename.indexOf('.') !== -1) {
      filename = filename.substring(0, filename.lastIndexOf('.'));
      filename = filename.replaceAll('_', ' ');
      filename += '. (PDF, opens in a new tab)';
    }
    return filename;
  });
};



// WEBPACK FOOTER //
// ./assets/js/handlebars-helpers/util.js